import { Link } from 'react-router-dom';
const deliveryTools = [
  'Stripe',
  'AWS',
  'Shopify',
  'Microsoft',
  'GitHub',
  'GitLab',
  'Google Play',
  'App Store',
  'Firebase',
  'Twilio / SendGrid',
];

const SuccessfulCollaborations = () => {
  return (
    <section className='collaborationsWrapper'>
      <div className='containerFull'>
        <h3>Tools and platforms <span className='text-orange-pink'>we work with</span></h3>
        <div className='collaboration-logos'>
          <div className='tools-chip-grid'>
            {deliveryTools.map((tool) => (
              <span className='tools-chip' key={tool}>{tool}</span>
            ))}
          </div>
        </div>
        <div className='collaboration-footer'>
          <p>Need a team that can safely improve your existing software?</p>
          <Link to={`/contact-us`} className='baseButton orangePinkGradientBttn'>
            <span>Book a Backlog Review</span>
          </Link>
        </div>
        
      </div>

    </section>

  );
}

export default SuccessfulCollaborations;